export default __webpack_public_path__ + "static/media/icone-death.2213e4fd.svg";